<template>
  <div>
    <section
      class="relative flex sm:flex-col sm:items-center md:items-start md:flex-row bg-beige rounded-xl p-9 mb-7 z-50"
    >
      <div class="md:w-2/6 lg:w-1/6 lg:mx-4">
        <div class="flex">
          <div class="bg-white rounded-full">
            <svg
              width="158"
              height="158"
              viewBox="0 0 158 158"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="79" cy="79" r="79" fill="white" />
              <g clip-path="url(#clip0_166_3473)">
                <path
                  d="M56.8029 96.1218H47.6226C46.8599 96.1218 46.2358 95.4977 46.2358 94.735C46.2358 93.9723 46.8599 93.3483 47.6226 93.3483H56.8029C57.5656 93.3483 58.1897 93.9723 58.1897 94.735C58.1897 95.4977 57.5656 96.1218 56.8029 96.1218Z"
                  fill="#591144"
                />
                <path
                  d="M88.254 107.812C86.8117 107.812 85.4111 107.23 84.371 106.19C83.3171 105.136 82.7485 103.749 82.7485 102.265C82.7485 100.782 83.331 99.3948 84.3849 98.3409L86.2709 96.5104C86.8256 95.9834 87.6993 95.9973 88.2262 96.5381C88.7532 97.0928 88.7393 97.9665 88.1985 98.4935L86.3264 100.31C85.8133 100.823 85.5221 101.517 85.5221 102.252C85.5221 102.987 85.8133 103.694 86.3264 104.207C86.8533 104.734 87.5883 105.025 88.3094 105.011C89.0028 104.997 89.6269 104.706 90.0706 104.207L101.262 93.7091C101.525 93.4734 101.858 93.3347 102.205 93.3347H110.872C111.635 93.3347 112.259 93.9588 112.259 94.7215C112.259 95.4842 111.635 96.1082 110.872 96.1082H102.759L92.0537 106.148C91.1662 107.133 89.8349 107.757 88.3788 107.785C88.3372 107.812 88.2956 107.812 88.254 107.812Z"
                  fill="#EA5160"
                />
                <path
                  d="M37.3882 69.7736C36.6255 69.7736 36.0015 69.1635 36.0015 68.3869C36.0015 67.6242 36.6255 67.0001 37.3882 67.0001H120.594C121.356 67.0001 121.98 67.6242 121.98 68.3869C121.98 69.1496 121.356 69.7736 120.594 69.7736H37.3882Z"
                  fill="#EA5160"
                />
                <path
                  d="M36.4639 69.7738C35.7012 69.7738 35.0771 69.1636 35.0771 68.387C35.0771 67.6243 35.7012 67.0002 36.4639 67.0002H81.7689C82.5316 67.0002 83.1557 67.6243 83.1557 68.387C83.1557 69.1497 82.5316 69.7738 81.7689 69.7738H36.4639Z"
                  fill="#591144"
                />
                <path
                  d="M60.9079 100.255C59.424 100.255 58.0373 99.6722 56.9833 98.6321C55.9294 97.5782 55.3608 96.1914 55.3608 94.7076C55.3608 93.2238 55.9433 91.837 56.9972 90.7831L71.9326 75.9032C72.4734 75.3623 73.3471 75.3623 73.9018 75.9032C74.4426 76.444 74.4426 77.3315 73.9018 77.8724L58.9525 92.7523C58.4256 93.2793 58.1344 93.9726 58.1344 94.7076C58.1344 95.4426 58.4256 96.1498 58.9387 96.6629C59.9926 97.703 61.8093 97.7169 62.8493 96.6629L74.4704 85.0419C75.0112 84.5011 75.8848 84.5011 76.4257 85.0419C76.9665 85.5828 76.9665 86.4564 76.4257 86.9972L64.8047 98.6183C63.7785 99.6722 62.3917 100.255 60.9079 100.255Z"
                  fill="#EA5160"
                />
                <path
                  d="M71.4052 101.683C70.0601 101.683 68.7011 101.045 67.4946 99.8384C66.4406 98.7845 65.8721 97.3978 65.8721 95.9139C65.8721 94.4301 66.4545 93.0433 67.5084 91.9894L74.8444 84.6951C75.3852 84.1542 76.2589 84.1542 76.7997 84.6951C77.3406 85.2359 77.3406 86.1095 76.7997 86.6504L69.4638 93.9447C68.9368 94.4717 68.6456 95.1651 68.6456 95.9001C68.6456 96.635 68.9368 97.3423 69.4499 97.8693C69.9214 98.3407 70.6425 98.8955 71.3914 98.8955C71.4052 98.8955 71.4191 98.8955 71.433 98.8955C72.0015 98.8816 72.5978 98.5349 73.1942 97.8693L80.4746 90.5888C81.0155 90.0479 81.8891 90.0479 82.43 90.5888C82.9708 91.1296 82.9708 92.0033 82.43 92.5441L75.205 99.7691C74.1371 100.976 72.8891 101.641 71.53 101.669C71.4884 101.669 71.4468 101.683 71.4052 101.683Z"
                  fill="#EA5160"
                />
                <path
                  d="M79.4625 104.914C78.0202 104.914 76.6196 104.332 75.5795 103.292C74.5256 102.238 73.957 100.851 73.957 99.367C73.957 97.8832 74.5395 96.4964 75.5934 95.4425L80.5025 90.5888C81.0434 90.048 81.917 90.0619 82.4579 90.6027C82.9987 91.1435 82.9848 92.0311 82.444 92.558L77.5349 97.3978C77.0079 97.9109 76.7305 98.6181 76.7305 99.3531C76.7305 100.088 77.0218 100.795 77.5349 101.308C78.0618 101.835 78.7552 102.154 79.5179 102.113C80.2113 102.099 80.8353 101.808 81.2791 101.308L86.1605 96.4271C86.7013 95.8862 87.575 95.8862 88.1158 96.4271C88.6567 96.9679 88.6567 97.8416 88.1158 98.3824L83.2899 103.208C82.3746 104.235 81.0434 104.845 79.5873 104.886C79.5595 104.914 79.5179 104.914 79.4625 104.914Z"
                  fill="#EA5160"
                />
                <path
                  d="M89.3495 87.0803C87.935 87.0803 86.5067 86.5395 85.425 85.4578L78.0613 78.0941H73.0967C72.334 78.0941 71.71 77.4701 71.71 76.7074C71.71 75.9446 72.334 75.3206 73.0967 75.3206H78.6299C79.0043 75.3206 79.351 75.4731 79.6145 75.7228L87.3803 83.4886C88.462 84.5703 90.2232 84.5703 91.3048 83.4886C92.3865 82.4069 92.3865 80.6457 91.3048 79.5641L81.0983 69.3575C80.5575 68.8167 80.5575 67.943 81.0983 67.4022C81.6391 66.8614 82.5128 66.8614 83.0536 67.4022L93.274 77.6087C95.4374 79.7721 95.4374 83.2944 93.274 85.4578C92.1924 86.5395 90.764 87.0803 89.3495 87.0803Z"
                  fill="#591144"
                />
              </g>
              <defs>
                <clipPath id="clip0_166_3473">
                  <rect
                    x="36"
                    y="67"
                    width="85.979"
                    height="40.8123"
                    rx="4.622"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div class="md:w-4/6 lg:w-5/6 lg:mx-4 md:pr-10 lg:pr-28">
        <h4 class="font-bold text-violet text-xl mb-4">
          Umowa agencyjna z Ekspertem
          <span class="font-normal"> - Niezbędna do rozliczeń z Ekspertem</span>
        </h4>
        <p class="text-sm">
          Zweryfikuj czy wszystkie dane są poprawne. Jeśli nie, skorzystaj z
          przycisku wstecz i popraw dane. Po zaakceptowaniu podsumowania nie
          będzie możliwości edycji wprowadzonych danych. Po potwierdzeniu
          formularza otrzymasz na wskazany adres mailowy link z zaproszeniem do
          podpisania <span v-if="twoCompanies">umów</span
          ><span v-else>umowy</span>.
        </p>
      </div>
    </section>
    <template v-if="step === 20">
      <form
        v-show="!loading"
        id="agentDataForm"
        class="recruitmentForm"
        method="POST"
        :action="action"
      >
        <input type="hidden" name="data[step][20]" :value="1" />
        <header
          class="relative flex items-center bg-cyan-light uppercase font-bold text-sm p-4 rounded-t-xl z-10"
        >
          Dane agenta
        </header>
        <section class="relative bg-white px-12 py-8 rounded-b-xl z-50 mb-10">
          <div v-if="item && item.data" class="max-w-5xl m-auto">
            <div class="flex w-full mb-8 -mx-3">
              <div class="w-1/3 px-3">
                <div class="flex flex-col">
                  <label class="text-dark text-xs font-bold mb-1">NIP</label>
                  <input
                    type="text"
                    class="nip border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                    name="data[agent][nip]_"
                    :disabled="true"
                    required
                    v-model="item.data.agent.nip"
                    @keyup="nipBir"
                  />
                  <input
                    type="hidden"
                    name="data[agent][nip]"
                    v-model="item.data.agent.nip"
                  />
                </div>
              </div>
              <div v-if="birLoading" class="w-1/4 px-3">
                <spinner></spinner>
              </div>
              <div class="w-2/3 px-3">
                <div class="flex flex-col">
                  <label class="text-dark text-xs font-bold mb-1"
                    >Nazwa firmy</label
                  >
                  <input
                    type="text"
                    class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                    name="data[agent][name]_"
                    :disabled="true"
                    required
                    v-model="item.data.agent.name"
                  />
                  <input
                    type="hidden"
                    name="data[agent][name]"
                    v-model="item.data.agent.name"
                  />
                </div>
              </div>
            </div>
            <div class="flex flex-wrap lg:flex-nowrap w-full mb-8 -mx-3">
              <div class="w-1/3 px-3">
                <div class="flex flex-col">
                  <label class="text-dark text-xs font-bold mb-1">Miasto</label>
                  <input
                    type="text"
                    class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                    name="address[agent][city]"
                    :disabled="true"
                    required
                    v-model="item.address.agent.city"
                  />
                  <input
                    type="hidden"
                    name="address[agent][city]"
                    v-model="item.address.agent.city"
                  />
                </div>
              </div>
              <div class="w-1/3 px-3">
                <div class="flex flex-col">
                  <label class="text-dark text-xs font-bold mb-1">Ulica</label>
                  <input
                    type="text"
                    class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                    name="address[agent][street]"
                    :disabled="true"
                    required
                    v-model="item.address.agent.street"
                  />
                  <input
                    type="hidden"
                    name="address[agent][city]"
                    v-model="item.address.agent.street"
                  />
                </div>
              </div>
              <div class="w-1/3 lg:w-[10%] px-3">
                <div class="flex flex-col">
                  <label class="text-dark text-xs font-bold mb-1"
                    >Budynek</label
                  >
                  <input
                    type="text"
                    class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                    name="address[agent][number]"
                    :disabled="true"
                    required
                    v-model="item.address.agent.number"
                  />
                  <input
                    type="hidden"
                    name="address[agent][number]"
                    v-model="item.address.agent.number"
                  />
                </div>
              </div>
              <div class="w-1/3 mt-5 lg:mt-0 lg:w-[10%] px-3">
                <div class="flex flex-col">
                  <label class="text-dark text-xs font-bold mb-1">Lokal</label>
                  <input
                    type="text"
                    class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                    name="address[agent][flat]"
                    :disabled="true"
                    required
                    v-model="item.address.agent.flat"
                  />
                  <input
                    type="hidden"
                    name="address[agent][flat]"
                    v-model="item.address.agent.flat"
                  />
                </div>
              </div>
              <div class="w-1/3 mt-5 lg:mt-0 lg:w-[13%] px-3">
                <div class="flex flex-col">
                  <label class="text-dark text-xs font-bold mb-1"
                    >Kod pocztowy</label
                  >
                  <input
                    type="text"
                    class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                    name="address[agent][postal]"
                    :disabled="true"
                    required
                    v-model="item.address.agent.postal"
                  />
                  <input
                    type="hidden"
                    name="address[agent][postal]"
                    v-model="item.address.agent.postal"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5" v-if="item.data">
            <div class="flex relative text-justify pr-6 form-check-after">
              <input
                type="checkbox"
                class="opacity-0 -mt-1.5 h-8 w-8 z-50 relative cursor-pointer"
                id="companyGroup"
                name="data[consents][agent]"
                value="1"
                required
                v-model="item.data.consents.agent"
              />
              <label
                class="label-checkbox w-full block mb-0 before:content-[''] before:absolute before:left-0 before:top-[3px] before:border before:border-pink before:h-5 before:rounded-md before:inline-block before:w-5 before:cursor-pointer after:content-[''] after:opacity-0 after:absolute after:top-[6px] after:left-[7px] after:w-[6px] after:h-[12px] after:border-r-2 after:border-b-2 after:border-pink after:rotate-45 after:text-pink after:block after:z-20 after:cursor-pointer"
                for="companyGroup"
              >
                <span v-if="twoCompanies" class="pointerable text-sm">
                  Zapoznałem się z poniższą informacją dotyczącą przetwarzania
                  danych osobowych: W przypadku zawarcia umowy w zakresie linii
                  biznesowych “Biznes” lub “Fotowoltaika” administratorem danych
                  osobowych jest ANG Biznes S.A. z siedzibą w Warszawie
                  (00-728), ul. Dziekońskiego 1. W zakresie zawarcia umowy na
                  pozostałe linie biznesowe administratorem danych osobowych
                  jest Grupa ANG S.A. z siedzibą w Warszawie (00-728), ul.
                  Dziekońskiego 1. Kontakt z każdą ze spółek<span
                    class="text-sm"
                    :class="{ hidden: this.expanded.agent }"
                    >...</span
                  >
                </span>
                <span v-else-if="isGroup" class="pointerable text-sm">
                  Zapoznałem się z poniższą informacją dotyczącą przetwarzania
                  danych osobowych: Administratorem danych osobowych jest Grupa
                  ANG S.A. z siedzibą w Warszawie (00-728), ul. Dziekońskiego 1.
                  Kontakt ze spółką<span
                    class="text-sm"
                    :class="{ hidden: this.expanded.agent }"
                    >...</span
                  >
                </span>
                <span v-else-if="isBusiness" class="pointerable text-sm">
                  Zapoznałem się z poniższą informacją dotyczącą przetwarzania
                  danych osobowych: Administratorem danych osobowych jest ANG
                  Biznes S.A. z siedzibą w Warszawie (00-728), ul. Dziekońskiego
                  1. Kontakt ze spółką<span
                    class="text-sm"
                    :class="{ hidden: this.expanded.agent }"
                    >...</span
                  >
                </span>
                <span
                  @click.prevent.stop="expanded.agent = !expanded.agent"
                  class="text-sm cursor-pointer uppercase text-violet font-bold"
                  :class="{ hidden: expanded.agent }"
                >
                  rozwiń
                </span>
                <transition v-on:enter="enter" v-on:leave="leave">
                  <span
                    class="text-sm transition duration-300 ease-in-out"
                    :class="{
                      'block opacity-0 h-0 p-0 origin-top scale-y-0 ':
                        !this.expanded.agent,
                    }"
                    >- pisemnie na ww. adres lub mailowo:
                    <a href="mailto:kontakt@grupaang.pl">kontakt@grupaang.pl</a
                    >. <span v-if="twoCompanies">Każda ze Spółek </span
                    ><span v-else>Spółka </span>powołała Inspektora Ochrony
                    Danych, z którym można kontaktować się pisemnie na adres
                    <span v-if="twoCompanies">danej </span>spółki z dopiskiem
                    “Inspektor Ochrony Danych” lub mailowo:
                    <a href="mailto:">iod@grupaang.pl</a>.
                    <span v-if="parseInt(item.data.is_company) === 0"
                      >Dane osobowe Agenta będącego osobą fizyczną, podane w
                      niniejszym procesie są przetwarzane przez
                      <span v-if="twoCompanies">daną </span>spółkę w celu
                      zawarcia umowy, tj. na podstawie art. 6 ust. 1 lit. b
                      ogólnego rozporządzenia o ochronie danych (“RODO”).</span
                    >
                    <span v-else
                      >Dane osób reprezentujących Agenta są przetwarzane w celu
                      zawarcia umowy z Agentem, w tym weryfikacji ich umocowania
                      do zawarcia umowy i kontaktu w związku z zawarciem umowy,
                      co stanowi prawnie uzasadniony interes administratora
                      zgodnie z art. 6 ust. 1 lit. f RODO.
                    </span>
                    Dane osobowe będą przechowywane do czasu zawarcia umowy z
                    Agentem, a maksymalnie przez 1 rok od dnia rozpoczęcia
                    uzupełniania formularzy w niniejszym procesie. Po tym
                    czasie, jeśli umowa nie zostanie ostatecznie zawarta, dane
                    osobowe zostaną usunięte. W przypadku zawarcia umowy z
                    Agentem, dane osobowe będą przetwarzane dalej w celach i
                    zakresie wskazanym w klauzuli informacyjnej zawartej w
                    treści umowy. Podanie danych jest dobrowolne, ale niezbędne
                    do zawarcia umowy. Odbiorcami danych są podmioty świadczące
                    usługi informatyczne na rzecz danego administratora na
                    podstawie zawartych umów powierzenia przetwarzania danych
                    osobowych. Osoba, której dane dotyczą ma prawo dostępu do
                    danych, ich sprostowania, ograniczenia przetwarzania,
                    usunięcia, przenoszenia, jak również wniesienia sprzeciwu
                    wobec przetwarzania danych osobowych. Ponadto, w razie
                    uznania, że przetwarzanie danych narusza RODO, dana osoba ma
                    prawo wnieść skargę do Prezesa Urzędu Ochrony Danych
                    Osobowych.
                    <span
                      @click.prevent.stop="expanded.agent = !expanded.agent"
                      class="text-sm cursor-pointer uppercase text-violet font-bold"
                      :class="{ hidden: !this.expanded.agent }"
                    >
                      zwiń
                    </span>
                  </span>
                </transition>
              </label>
              <input
                type="hidden"
                name="data[agent][is_company]"
                v-model="item.data.agent.is_company"
              />
              <input
                type="hidden"
                name="data[agent][company_type]"
                v-model="item.data.agent.company_type"
              />
            </div>
          </div>
          <div
            class="relative mt-3 bg-[#ffe6e6] p-5 mt-6 rounded-lg border border-red z-50"
            v-if="error"
          >
            <h5 class="text-red font-bold">Wystąpił błąd!</h5>
            <label class="text-red mt-3 error">{{ error }}</label>
          </div>
        </section>
        <div v-if="loading || sending" class="flex justify-center my-3">
          <spinner position="ml-auto" :grid="true"></spinner>
        </div>
        <div v-else class="flex justify-end mt-6">
          <!-- <div
            class="flex items-center bg-transparent border border-violet border-solid rounded-3xl py-3 px-12 font-bold text-violet cursor-pointer z-50 focus:outline-none"
            @click="$emit('back')"
          >
            Wstecz1
          </div> -->
          <button
            class="flex items-center bg-pink border border-pink border-solid rounded-3xl py-3 px-12 font-bold text-white z-50 focus:outline-none"
            type="submit"
          >
            Dalej2X
          </button>
        </div>
      </form>
    </template>
    <template v-if="step === 21">
      <form
        v-show="!loading"
        id="agentRepsDataForm"
        class="recruitmentForm"
        method="POST"
        :action="action"
      >
        <representation-form
          v-if="
            item.data &&
            item.data.agent &&
            item.data.agent.company_type &&
            parseInt(item.data.agent.company_type) > 0
          "
          :data="data"
          :step="step"
          :company_type="item.data.agent.company_type"
          :board="item.data.agent.board"
          :reps="item.data.agent.reps"
          repsName="data[agent][reps]"
          boardName="data[agent][board]"
          @back="$emit('back')"
          :shortcut="shortcut"
        >
          <div class="flex flex-col" v-if="item.data">
            <div class="mb-5">
              <div class="flex relative text-justify pr-6 form-check-after">
                <input type="hidden" name="data[step][21]" :value="1" />
                <input
                  type="checkbox"
                  class="opacity-0 -mt-1.5 h-8 w-8 z-50 relative cursor-pointer"
                  id="agent_board"
                  name="data[consents][agent_board]"
                  value="1"
                  required
                  v-model="item.data.consents.agent_board"
                />
                <label
                  class="label-checkbox w-full block mb-0 before:content-[''] before:absolute before:left-0 before:top-[3px] before:border before:border-pink before:h-5 before:rounded-md before:inline-block before:w-5 before:cursor-pointer after:content-[''] after:opacity-0 after:absolute after:top-[6px] after:left-[7px] after:w-[6px] after:h-[12px] after:border-r-2 after:border-b-2 after:border-pink after:rotate-45 after:text-pink after:block after:z-20 after:cursor-pointer"
                  for="agent_board"
                >
                  <span class="cursor-pointer text-sm">
                    Potwierdzam, że wszyscy
                    <span v-if="parseInt(item.data.agent.company_type) === 1"
                      >członkowie zarządu</span
                    ><span v-else>wspólnicy</span> Agenta zostali przeze mnie
                    poinformowani o przekazaniu ich numerów<span
                      :class="{ hidden: this.expanded.board }"
                      >...</span
                    >
                    <span
                      @click.prevent.stop="expanded.board = !expanded.board"
                      class="cursor-pointer uppercase text-violet font-bold"
                      :class="{ hidden: this.expanded.board }"
                    >
                      rozwiń
                    </span>
                  </span>
                  <transition v-on:enter="enter" v-on:leave="leave">
                    <span
                      class="text-sm transition duration-300 ease-in-out"
                      :class="{
                        'block opacity-0 h-0 p-0 origin-top scale-y-0 ':
                          !this.expanded.board,
                      }"
                    >
                      telefonów i adresów e-mail do ANG w celach związanych z
                      zawarciem i realizacją umowy agencyjnej, w tym w celu
                      kontaktu w związku z realizacją umowy agencyjnej, co
                      stanowi prawnie uzasadniony interes administratora zgodnie
                      z art. 6 ust. 1 lit. f RODO.
                      <span
                        @click.prevent.stop="expanded.board = !expanded.board"
                        class="cursor-pointer uppercase text-violet font-bold"
                        :class="{ hidden: !this.expanded.board }"
                      >
                        zwiń
                      </span>
                    </span>
                  </transition>
                </label>
              </div>
            </div>
          </div>
        </representation-form>
      </form>
    </template>
    <template v-if="step === 22">
      <form
        v-show="!loading"
        id="agentConfirmForm"
        class="recruitmentForm"
        method="POST"
        :action="action"
      >
        <input type="hidden" name="data[step][22]" :value="1" />
        <input type="hidden" name="agent_confirmed" :value="1" />
        <header
          v-if="item && item.data"
          class="relative flex bg-cyan-light uppercase font-bold text-sm p-4 rounded-t-xl z-50"
        >
          Podsumowanie
        </header>
        <section
          v-if="item && item.data"
          class="relative bg-white px-12 pt-8 pb-12 rounded-b-xl z-50"
        >
          <div class="max-w-5xl m-auto">
            <h4
              class="uppercase text-violet font-bold text-sm mb-8 min-h-[25px]"
            >
              Dane Agenta
            </h4>
            <div class="flex w-full mb-14 -mx-3 text-xs">
              <div class="w-1/2 px-3">
                <p class="font-bold pb-5">{{ item.data.agent.name }}</p>
                <p>
                  {{ item.address.agent.street }}
                  {{ item.address.agent.number }}
                  <span
                    v-if="
                      item.address.agent.flat &&
                      item.address.agent.flat.length > 0
                    "
                  >
                    lok. {{ item.address.agent.flat }}
                  </span>
                </p>
                <p>
                  {{ item.address.agent.postal }} {{ item.address.agent.city }}
                </p>
                <p>NIP: {{ item.data.agent.nip }}</p>
              </div>
            </div>
            <hr
              v-if="
                parseInt(item.data.agent.is_company) === 1 &&
                parseInt(item.data.agent.company_type) > 0
              "
              class="my-10"
            />
            <template
              v-if="
                parseInt(item.data.agent.is_company) === 1 &&
                parseInt(item.data.agent.company_type) > 0
              "
            >
              <div class="flex w-full mb-8 -mx-3">
                <div class="w-1/2 px-3">
                  <h4
                    v-if="parseInt(item.data.agent.company_type) === 1"
                    class="uppercase text-violet font-bold text-sm mb-8 min-h-[25px]"
                  >
                    Zarząd spółki
                  </h4>
                  <h4
                    v-if="parseInt(item.data.agent.company_type) > 1"
                    class="uppercase text-violet font-bold text-sm mb-8 min-h-[25px]"
                  >
                    Wspólnicy
                  </h4>
                  <div
                    v-for="(el, k) in item.data.agent.board"
                    :key="'board_' + k"
                    class="flex flex-col"
                  >
                    <p class="font-bold">
                      {{ el.last_name }} {{ el.first_name }}
                    </p>
                    <p>{{ el.position }}</p>

                    <p>+48 {{ el.phone }}</p>
                    <p>{{ el.email }}</p>
                    <p><strong>PESEL:</strong> {{ el.pesel }}</p>
                    <p>
                      <strong>KRK:</strong>
                      {{
                        dictionary.krkOptions.filter(
                          (obj) => obj.val === parseInt(el.krk)
                        )[0].text
                      }}
                    </p>
                  </div>
                </div>
                <div class="w-1/2 px-3">
                  <h4
                    class="uppercase text-violet font-bold text-sm mb-8 min-h-[25px]"
                  >
                    Reprezentanci spółki
                  </h4>
                  <div
                    v-for="(el, k) in item.data.agent.reps"
                    :key="'board_' + k"
                    class="flex flex-col"
                  >
                    <p class="font-bold">
                      {{ el.last_name }} {{ el.first_name }}
                    </p>
                    <p>{{ el.position }}</p>
                    <p>{{ el.phone }}</p>
                    <p>{{ el.email }}</p>
                  </div>
                </div>
              </div>
            </template>
            <hr class="my-10" />
            <h4
              class="uppercase text-violet font-bold text-sm mb-8 min-h-[25px]"
            >
              Oświadczenia
            </h4>
            <div class="flex relative text-justify mb-5 pr-6">
              <input
                type="checkbox"
                class="opacity-0 -mt-1.5 h-8 w-8 z-50 relative cursor-pointer"
                name="data[consents][agent]"
                :disabled="true"
                value="1"
                required
                v-model="item.data.consents.agent"
              />
              <label
                class="label-checkbox w-full block mb-0 before:content-[''] before:absolute before:left-0 before:top-[3px] before:border before:border-pink before:h-5 before:rounded-md before:inline-block before:w-5 before:cursor-pointer after:content-[''] after:opacity-0 after:absolute after:top-[6px] after:left-[7px] after:w-[6px] after:h-[12px] after:border-r-2 after:border-b-2 after:border-pink after:rotate-45 after:text-pink after:block after:z-20 after:cursor-pointer after:border-[#cbcbcb] before:border-[#cbcbcb] text-[#cdcdcd]"
              >
                <span v-if="twoCompanies" class="pointerable text-sm">
                  Zapoznałem się z poniższą informacją dotyczącą przetwarzania
                  danych osobowych: W przypadku zawarcia umowy w zakresie linii
                  biznesowych “Biznes” lub “Fotowoltaika” administratorem danych
                  osobowych jest ANG Biznes S.A. z siedzibą w Warszawie
                  (00-728), ul. Dziekońskiego 1. W zakresie zawarcia umowy na
                  pozostałe linie biznesowe administratorem danych osobowych
                  jest Grupa ANG S.A. z siedzibą w Warszawie (00-728), ul.
                  Dziekońskiego 1. Kontakt z każdą ze spółek<span
                    class="text-sm"
                    :class="{ hidden: this.expanded.agent }"
                    >...</span
                  >
                </span>
                <span v-else-if="isGroup" class="pointerable text-sm">
                  Zapoznałem się z poniższą informacją dotyczącą przetwarzania
                  danych osobowych: Administratorem danych osobowych jest Grupa
                  ANG S.A. z siedzibą w Warszawie (00-728), ul. Dziekońskiego 1.
                  Kontakt ze spółką<span
                    class="text-sm"
                    :class="{ hidden: this.expanded.agent }"
                    >...</span
                  >
                </span>
                <span v-else-if="isBusiness" class="pointerable text-sm">
                  Zapoznałem się z poniższą informacją dotyczącą przetwarzania
                  danych osobowych: Administratorem danych osobowych jest ANG
                  Biznes S.A. z siedzibą w Warszawie (00-728), ul. Dziekońskiego
                  1. Kontakt ze spółką<span
                    class="text-sm"
                    :class="{ hidden: this.expanded.agent }"
                    >...</span
                  >
                </span>
                <span
                  @click.prevent.stop="expanded.agent = !expanded.agent"
                  class="text-sm cursor-pointer uppercase text-violet font-bold opacity-60"
                  :class="{ hidden: this.expanded.agent }"
                >
                  rozwiń
                </span>
                <transition v-on:enter="enter" v-on:leave="leave">
                  <span
                    class="text-sm transition duration-300 ease-in-out"
                    :class="{
                      'block opacity-0 h-0 p-0 origin-top scale-y-0 ':
                        !this.expanded.agent,
                    }"
                  >
                    - pisemnie na ww. adres lub mailowo:
                    <a href="mailto:kontakt@grupaang.pl">kontakt@grupaang.pl</a
                    >. <span v-if="twoCompanies">Każda ze Spółek </span
                    ><span v-else>Spółka </span>powołała Inspektora Ochrony
                    Danych, z którym można kontaktować się pisemnie na adres
                    <span v-if="twoCompanies">danej </span>spółki z dopiskiem
                    “Inspektor Ochrony Danych” lub mailowo:
                    <a href="mailto:">iod@grupaang.pl</a>.
                    <span v-if="parseInt(item.data.is_company) === 0"
                      >Dane osobowe Agenta będącego osobą fizyczną, podane w
                      niniejszym procesie są przetwarzane przez
                      <span v-if="twoCompanies">daną </span>spółkę w celu
                      zawarcia umowy, tj. na podstawie art. 6 ust. 1 lit. b
                      ogólnego rozporządzenia o ochronie danych (“RODO”).</span
                    >
                    <span v-else
                      >Dane osób reprezentujących Agenta są przetwarzane w celu
                      zawarcia umowy z Agentem, w tym weryfikacji ich umocowania
                      do zawarcia umowy i kontaktu w związku z zawarciem umowy,
                      co stanowi prawnie uzasadniony interes administratora
                      zgodnie z art. 6 ust. 1 lit. f RODO.
                    </span>
                    Dane osobowe będą przechowywane do czasu zawarcia umowy z
                    Agentem, a maksymalnie przez 1 rok od dnia rozpoczęcia
                    uzupełniania formularzy w niniejszym procesie. Po tym
                    czasie, jeśli umowa nie zostanie ostatecznie zawarta, dane
                    osobowe zostaną usunięte. W przypadku zawarcia umowy z
                    Agentem, dane osobowe będą przetwarzane dalej w celach i
                    zakresie wskazanym w klauzuli informacyjnej zawartej w
                    treści umowy. Podanie danych jest dobrowolne, ale niezbędne
                    do zawarcia umowy. Odbiorcami danych są podmioty świadczące
                    usługi informatyczne na rzecz danego administratora na
                    podstawie zawartych umów powierzenia przetwarzania danych
                    osobowych. Osoba, której dane dotyczą ma prawo dostępu do
                    danych, ich sprostowania, ograniczenia przetwarzania,
                    usunięcia, przenoszenia, jak również wniesienia sprzeciwu
                    wobec przetwarzania danych osobowych. Ponadto, w razie
                    uznania, że przetwarzanie danych narusza RODO, dana osoba ma
                    prawo wnieść skargę do Prezesa Urzędu Ochrony Danych
                    Osobowych.
                    <span
                      @click.prevent.stop="expanded.board = !expanded.board"
                      class="text-sm cursor-pointer uppercase text-violet font-bold opacity-60"
                      :class="{ hidden: !this.expanded.agent }"
                    >
                      zwiń
                    </span>
                  </span>
                </transition>
              </label>
            </div>
            <div
              v-if="parseInt(item.data.agent.is_company) === 1"
              class="flex relative text-justify mb-5 pr-6"
            >
              <input
                type="checkbox"
                class="opacity-0 -mt-1.5 h-8 w-8 z-50 relative cursor-pointer"
                name="data[consents][agent_board]"
                id="agent_board2"
                :disabled="true"
                value="1"
                required
                v-model="item.data.consents.agent_board"
              />
              <label
                for="agent_board2"
                class="label-checkbox w-full block mb-0 before:content-[''] before:absolute before:left-0 before:top-[3px] before:border before:border-pink before:h-5 before:rounded-md before:inline-block before:w-5 before:cursor-pointer after:content-[''] after:opacity-0 after:absolute after:top-[6px] after:left-[7px] after:w-[6px] after:h-[12px] after:border-r-2 after:border-b-2 after:border-pink after:rotate-45 after:text-pink after:block after:z-20 after:cursor-pointer after:border-[#cbcbcb] before:border-[#cbcbcb] text-[#cdcdcd]"
              >
                <span class="cursor-pointer text-sm">
                  Potwierdzam, że wszyscy
                  <span v-if="parseInt(item.data.agent.company_type) === 1"
                    >członkowie zarządu</span
                  ><span v-else>wspólnicy</span> Agenta zostali przeze mnie
                  poinformowani o przekazaniu ich numerów
                  <span :class="{ hidden: this.expanded.board }">...</span>
                  <span
                    @click.prevent.stop="expanded.board = !expanded.board"
                    class="cursor-pointer uppercase text-violet font-bold opacity-60"
                    :class="{ hidden: this.expanded.board }"
                  >
                    rozwiń
                  </span>
                </span>
                <transition v-on:enter="enter" v-on:leave="leave">
                  <span
                    class="text-sm transition duration-300 ease-in-out"
                    :class="{
                      'block opacity-0 h-0 p-0 origin-top scale-y-0 ':
                        !this.expanded.board,
                    }"
                  >
                    telefonów i adresów e-mail do ANG w celach związanych z
                    zawarciem i realizacją umowy agencyjnej, w tym w celu
                    kontaktu w związku z realizacją umowy agencyjnej, co stanowi
                    prawnie uzasadniony interes administratora zgodnie z art. 6
                    ust. 1 lit. f RODO.
                    <span
                      @click.prevent.stop="expanded.board = !expanded.board"
                      class="cursor-pointer uppercase text-violet font-bold opacity-60"
                      :class="{ hidden: !this.expanded.board }"
                    >
                      zwiń
                    </span>
                  </span>
                </transition>
              </label>
            </div>
          </div>
        </section>
        <div
          class="relative mt-3 bg-[#ffe6e6] p-5 mt-6 rounded-lg border border-red z-50"
          v-if="error"
        >
          <h5 class="text-red font-bold">Wystąpił błąd!</h5>
          <label class="text-red mt-3 error">{{ error }} </label>
        </div>
        <template>
          <div v-if="loading || sending" class="flex justify-center my-3">
            <spinner position="ml-auto" :grid="true"></spinner>
          </div>
          <div v-else>
            <div
              class="flex justify-between mt-8"
              v-if="
                typeof item.data === 'undefined' ||
                typeof item.data.step[21] === 'undefined'
              "
            >
              <div
                class="flex items-center bg-transparent border border-violet border-solid rounded-3xl py-3 px-12 font-bold text-violet cursor-pointer z-50 focus:outline-none"
                @click="$emit('back')"
              >
                Wstecz
              </div>
              <button
                type="submit"
                class="flex items-center bg-pink border border-pink border-solid rounded-3xl py-3 px-12 font-bold text-white z-50 cursor-pointer focus:outline-none"
              >
                Potwierdzam
              </button>
            </div>
            <div v-else class="flex justify-end mt-8">
              <div
                class="flex items-center bg-pink border border-pink border-solid rounded-3xl py-3 px-12 font-bold text-white z-50 cursor-pointer focus:outline-none"
                @click="$emit('forward')"
              >
                DalejX
              </div>
            </div>
          </div>
        </template>
      </form>
    </template>
  </div>
</template>

<script>
import spinner from "@/components/partials/misc/spinner";
import recruitment from "@/mixins/recruitment";
import api from "@/services/api";
import representationForm from "@/components/partials/forms/recrutation/representationForm.vue";
import $ from "jquery";
// import select from "@/components/partials/misc/select";
import Velocity from "velocity-animate";

export default {
  data() {
    return {
      birLoading: false,
      expanded: {
        agent: false,
        board: false,
      },
    };
  },
  components: {
    spinner,
    // "select-field": select,
    "representation-form": representationForm,
  },
  mixins: [recruitment],
  name: "agentForm",
  mounted() {
    if (this.item.data.agent.nip === this.item.partner.nip) {
      if (
        this.item.data.board &&
        (!this.item.data.agent?.board ||
          this.item.data.agent?.board?.length === 0)
      ) {
        this.item.data.agent.board = this.item.data.board;
      }
      if (
        this.item.data.reps &&
        (!this.item.data.agent?.reps ||
          this.item.data.agent?.reps?.length === 0)
      ) {
        this.item.data.agent.reps = this.item.data.reps;
      }
    }
  },
  methods: {
    toggleCardState() {
      this.expanded = !this.expanded;
    },
    getAddress(postal, addresType) {
      let self = this;
      let regex = new RegExp("^[0-9]{2}-[0-9]{3}$");
      if (regex.test(postal)) {
        api.get("/address/" + postal, {}, function (data) {
          if (data.length === 1) {
            self.item.address[addresType]["commune"] = data[0].gmina;
            self.item.address[addresType]["county"] = data[0].powiat;
            self.item.address[addresType]["city"] = data[0].miejscowosc;
            self.item.address[addresType]["post_office"] = data[0].miejscowosc;
            self.item.address[addresType]["street"] = data[0].ulica;
            $('select[name="address[' + addresType + '][province]"]').val(
              data[0].wojewodztwo
            );
            $('select[name="address[' + addresType + '][province]"]').change();
            self.$forceUpdate();
          } else {
            let tmp_ar = data.filter(function (obj) {
              return (
                obj.wojewodztwo.length > 0 &&
                obj.wojewodztwo !== data[0].wojewodztwo
              );
            });
            if (tmp_ar.length === 0) {
              $('select[name="address[' + addresType + '][province]"]').val(
                data[0].wojewodztwo
              );
              $(
                'select[name="address[' + addresType + '][province]"]'
              ).change();
              tmp_ar = data.filter(function (obj) {
                return obj.powiat.length > 0 && obj.powiat !== data[0].powiat;
              });
            } else {
              $('select[name="address[' + addresType + '][province]"]').val("");
              $(
                'select[name="address[' + addresType + '][province]"]'
              ).change();
            }

            if (tmp_ar.length === 0) {
              self.item.address[addresType]["county"] = data[0].powiat;
              tmp_ar = data.filter(function (obj) {
                return obj.gmina.length > 0 && obj.gmina !== data[0].gmina;
              });
            } else {
              self.item.address[addresType]["county"] = "";
            }

            if (tmp_ar.length === 0) {
              self.item.address[addresType]["commune"] = data[0].gmina;
              tmp_ar = data.filter(function (obj) {
                return obj.miejscowosc !== data[0].miejscowosc;
              });
            } else {
              self.item.address[addresType]["commune"] = "";
            }

            if (tmp_ar.length === 0) {
              self.item.address[addresType]["city"] = data[0].miejscowosc;
              self.item.address[addresType]["post_office"] =
                data[0].miejscowosc;
              tmp_ar = data.filter(function (obj) {
                return obj.ulica !== data[0].ulica;
              });
            } else {
              self.item.address[addresType]["city"] = "";
              self.item.address[addresType]["post_office"] = "";
            }

            if (tmp_ar.length === 0) {
              self.item.address[addresType]["street"] = data[0].ulica;
            } else {
              self.item.address[addresType]["street"] = "";
            }

            self.$forceUpdate();
          }
        });
      }
    },
    addRepresentationMember() {
      this.item.data.agent.reps.push({});
    },
    removeRepresentationMember(key) {
      this.item.data.agent.reps.splice(key, 1);
    },
    addBoardMember() {
      this.item.data.agent.board.push({});
    },
    removeBoardMember(key) {
      this.item.data.agent.board.splice(key, 1);
    },
    keyDownPrevent() {
      return true;
    },
    nipBir: function () {
      if (this.item.data.agent.nip.length === 10) {
        this.getBirData(this.item.data.agent.nip);
        if (this.item.data.agent.nip === this.item.partner.nip) {
          if (this.item.data.board) {
            this.item.data.agent.board = this.item.data.board;
          }
          if (this.item.data.reps) {
            this.item.data.agent.reps = this.item.data.reps;
          }
        }
      }
    },
    checkPhonesAndEmails(form) {
      this.error = null;
      let phones = [];
      let emails = [];
      let pesels = [];

      if (this.item.data.agent.board) {
        for (let i = 0; i < this.item.data.agent.board.length; i++) {
          if (
            this.item.data.agent.board[i].phone &&
            phones.indexOf(this.item.data.agent.board[i].phone) >= 0
          ) {
            this.error =
              "Numery telefonów Członków Zarządu i/lub Wspólników muszą być unikalne";
            return false;
          }
          phones.push(this.item.data.agent.board[i].phone);
          if (
            this.item.data.agent.board[i].pesel &&
            pesels.indexOf(this.item.data.agent.board[i].pesel) >= 0
          ) {
            this.error =
              "Numery PESEL Członków Zarządu i/lub Wspólników muszą być unikalne";
            return false;
          }
          pesels.push(this.item.data.agent.board[i].pesel);
          if (
            this.item.data.agent.board[i].email &&
            emails.indexOf(this.item.data.agent.board[i].email) >= 0
          ) {
            this.error =
              "Adresy e-mail Członków Zarządu i/lub Wspólników muszą być unikalne";
            return false;
          }
          emails.push(this.item.data.agent.board[i].email);
        }
      }

      if (this.item.data.agent.reps) {
        phones = [];
        emails = [];
        for (let i = 0; i < this.item.data.agent.reps.length; i++) {
          if (
            this.item.data.agent.reps[i].phone &&
            phones.indexOf(this.item.data.agent.reps[i].phone) >= 0
          ) {
            this.error = "Numery telefonów Reprezentantów muszą być unikalne";
            return false;
          }
          phones.push(this.item.data.agent.reps[i].phone);
        }
        for (let i = 0; i < this.item.data.agent.reps.length; i++) {
          if (
            this.item.data.agent.reps[i].email &&
            emails.indexOf(this.item.data.agent.reps[i].email) >= 0
          ) {
            this.error = "Adresy e-mail Reprezentantów muszą być unikalne";
            return false;
          }
          emails.push(this.item.data.agent.reps[i].email);
        }
      }
      $(form).submit();
    },
    getBirData: function (val) {
      this.birLoading = true;
      let self = this;
      $(".bir-error").text("");
      api.get(
        "/bir/" + val,
        [],
        function (data) {
          if (typeof self.item.address.agent === "undefined") {
            self.item.address.agent = {};
          }
          if (data.name.length > 0) {
            self.item.data.agent.name = data.name;
          }

          self.item.data.agent.is_company = parseInt(data.is_company);
          self.item.data.agent.company_type = parseInt(data.company_type);

          if (data.street.length > 0) {
            self.item.address.agent.street = data.street;
          }

          if (data.district.length > 0) {
            self.item.address.agent.province = data.district.toLowerCase();
          }

          if (data.number.length > 0) {
            self.item.address.agent.number = data.number;
          }
          if (data.loc.length > 0) {
            self.item.address.agent.flat = data.loc;
          }

          if (data.commune.length > 0) {
            self.item.address.agent.commune = data.commune;
          }

          if (data.county.length > 0) {
            self.item.address.agent.county = data.county;
          }

          if (data.postal.length > 0) {
            self.item.address.agent.postal = data.postal;
          }

          if (data.city.length > 0) {
            self.item.address.agent.city = data.city;
            self.item.address.agent.post_office = data.city;
          }
          self.birLoading = false;
          self.$forceUpdate();
        },
        function () {
          $(".bir-error").text("Nie udało się pobrać danych z bazy GUS");
          self.birLoading = false;
        }
      );
    },
    enter: function (el) {
      Velocity(el, "fadeIn", {
        duration: 500,
        easing: "easeInBack",
      });
    },
    leave: function (el) {
      Velocity(el, "fadeOut", {
        duration: 0,
        easing: "easeInBack",
      });
    },
  },
};
</script>
